module.exports = {"id":"191547","name":"Shinzo Koroki","rating":"72","photo":"./data/images/photos/0/191547.png","club":{"name":"Urawa Diamonds","logo":"./data/images/clubs/UrawaDiamonds.png"},"positions":["BU","ATT"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShinzoKoroki0.json
// module id = 3940
// module chunks = 0